import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import DateComparator from '_legacy/components/grid/comparators/DateComparator';
import DateEditor from '_legacy/components/grid/editors/DateEditor';
import DefaultDateFormatter from '_legacy/components/grid/formatters/DefaultDateFormatter';

export const getMaxRedeliveryHeading = (
    editable: boolean | ((params: any) => boolean),
    headerTooltip: string
) => ({
    colId: 'maxRedelivery',
    headerName: 'Max Redel',
    field: 'maxRedelivery',
    headerTooltip,
    valueFormatter: DefaultDateFormatter,
    cellEditorFramework: DateEditor,
    editable,
    equals: defaultObjEquals,
    comparator: DateComparator,
    type: ['privatable'],
    excelExportFormat: 'date',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'dateFilter',
    width: 85,
    hide: true,
});
